interface LanguageInterface {
    id: number;
    language: string;
    territory?: string;
    label: string;
}

class Language implements LanguageInterface {
    id: number;
    label: string;
    language: string;
    territory: string;
}

export {
    Language
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/languages/api.models.ts